/* Open YouTube in a separate tab, never inside the Shopify preview frame. */
(() => {
  'use strict';
  if (window.CFATVideoLinks) { window.CFATVideoLinks.scan(document); return; }
  function prepare(link) {
    if (!(link instanceof HTMLAnchorElement)) return;
    let url;
    try { url = new URL(link.getAttribute('href'), document.baseURI); }
    catch (error) { return; }
    if (!['https:', 'http:'].includes(url.protocol)) return;
    const host = url.hostname.toLowerCase();
    if (!(host === 'youtube.com' || host.endsWith('.youtube.com') || host === 'youtu.be')) return;
    link.target = '_blank';
    link.relList.add('noopener', 'noreferrer');
    if (!link.hasAttribute('aria-description')) link.setAttribute('aria-description', 'Opens YouTube in a new tab.');
  }
  function scan(root) {
    if (root instanceof HTMLAnchorElement) prepare(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(prepare);
  }
  function beforeActivation(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') return;
    const target = event.target;
    if (target instanceof Element) prepare(target.closest('a[href]'));
  }
  window.CFATVideoLinks = { scan };
  for (const type of ['pointerdown', 'click', 'keydown', 'contextmenu']) {
    window.addEventListener(type, beforeActivation, true);
  }
  function start() {
    scan(document);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') prepare(record.target);
        else record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
